import MachineMakeAndModelFilter from '../machines/machineMakeAndModelFilter';

export class InventoryItemFilter extends MachineMakeAndModelFilter {
  constructor(filter) {
    super();
    if (filter) {
      this.search = filter.search;
      this.carrierId = filter.carrierId;
      this.weightCategoryId = filter.weightCategoryId;
      this.couplerStyleId = filter.couplerStyleId;
      this.couplerStyleName = filter.couplerStyleName;
      this.productGroupId = filter.productGroupId;
      this.productId = filter.productId;
      this.soldStatus = filter.soldStatus;
      this.make = filter.make;
      this.machineId = filter.machineId;
      return this;
    }
    this.search = '';
    this.carrierId = '';
    this.weightCategoryId = '';
    this.couplerStyleId = '';
    this.couplerStyleName = '';
    this.productGroupId = '';
    this.productId = '';
    this.soldStatus = 2;
    this.make = '';
    this.machineId = '';
  }
}
